import type { SourceRef } from '../../shared/types.ts';

/** 回答が何を根拠にしているかを示す。書籍由来の知識はその旨を明示する。 */
export function Sources({ sources }: { sources: SourceRef[] }) {
  if (sources.length === 0) return null;

  return (
    <div className="sources">
      <p className="sources__heading">参照した知識</p>
      {sources.slice(0, 4).map((source) => (
        <div className="sources__item" key={`${source.docId}-${source.heading}`}>
          {source.title} / {source.heading}
          <span className="sources__badge">{source.authority === 'book' ? '書籍' : '公開情報'}</span>
        </div>
      ))}
    </div>
  );
}
